import React from 'react';
// gatsby
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
// styles
import styles from './instagram-feed.module.css';
//icons
import BroLogo from '../../../images/bro-logo-insta.inline.svg';

const instaCards = ['mila', 'morning', 'presents', 'team', 'team2', 'team3', 'ilona', 'dogs'];

interface InstagramFeed {
  backgroundColor?: string;
}

const InstagramFeed = ({ backgroundColor = '#fafafa' }: InstagramFeed) => {
  const data = useStaticQuery(graphql`
    query {
      mila: file(relativePath: { eq: "career/mila.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      morning: file(relativePath: { eq: "career/morning.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      presents: file(relativePath: { eq: "career/presents.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      team: file(relativePath: { eq: "career/team.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      team2: file(relativePath: { eq: "career/team2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      team3: file(relativePath: { eq: "career/team3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ilona: file(relativePath: { eq: "career/ilona.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      dogs: file(relativePath: { eq: "career/dogs.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  return (
    <div className={styles.container} style={{ backgroundColor }}>
      <div className={styles.common}>
        <div className={styles.instaHeader}>
          <BroLogo className={styles.logo} />
          <div className={styles.captures}>
            <h2 className={styles.header}>Our Instagram Feed</h2>
            <p className={styles.description}>24 posts</p>
          </div>
        </div>
        <a
          className={styles.link}
          href="https://www.instagram.com/brocoders__com/"
          rel="noopener noreferrer"
        >
          Follow Us
        </a>
      </div>
      <ul className={styles.list}>
        {instaCards.map((imageName) => (
          <li key={imageName} className={styles.card}>
            <Img fluid={data[imageName].childImageSharp.fluid} alt="" />
          </li>
        ))}
      </ul>
    </div>
  );
};
export default InstagramFeed;
